import React from 'react'

import './style.scss'
import data from './data.json'
import { Layout, SectionTitle, Intro, Header } from '../../../../components'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        exclusive={true}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            Text content communicates the main information in any given layout.
            It can be used for anything from a couple of words to long
            description fields.
          </p>
        </Intro>
        <SectionTitle>Variants</SectionTitle>
        <div className="showcase__title l-margin-top--xxlarge">
          Lead Paragraph
        </div>
        <p>
          Use to emphasize the opening paragraph of a page that summarizes its
          main ideas. Appears only once per page.
        </p>
        <table class="showcase-table">
          <thead>
            <th> </th>
            <th>Weight</th>
            <th>Color</th>
            <th>Font Values</th>
            <th>Usage</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <p class="c-text-content-lead--normal">
                  LeadParagraph / Normal
                </p>
              </td>
              <td>SemiLight 200</td>
              <td>#333</td>
              <td class="showcase-table__font-values">
                font-size: <strong>20px</strong>
                <br />
                line-height: <strong>30px</strong>
              </td>
              <td class="showcase-table__usage">
                For lead paragraphs on light backgrounds
              </td>
            </tr>
            <tr class="showcase-table__dark-row">
              <td>
                <p class="c-text-content-lead--light">LeadParagraph / Light</p>
              </td>
              <td>SemiLight 200</td>
              <td>#FFF</td>
              <td class="showcase-table__font-values">
                font-size: <strong>20px</strong>
                <br />
                line-height: <strong>30px</strong>
              </td>
              <td class="showcase-table__usage">
                For lead paragraphs on dark or primary green backgrounds
              </td>
            </tr>
          </tbody>
        </table>
        <div className="showcase__title l-margin-top--xxlarge">Body</div>
        <p>Use for standard body copy.</p>
        <table class="showcase-table">
          <tbody>
            <tr>
              <td>
                <p class="c-text-content-body--normal">Body / Normal</p>
              </td>
              <td>Book 300</td>
              <td>#333</td>
              <td class="showcase-table__font-values">
                font-size: <strong>16px</strong>
                <br />
                line-height: <strong>24px</strong>
              </td>
              <td class="showcase-table__usage">
                For body copy on light backgrounds
              </td>
            </tr>
            <tr class="showcase-table__dark-row">
              <td>
                <p class="c-text-content-body--light">Body / Light</p>
              </td>
              <td>Book 300</td>
              <td>#FFF</td>
              <td class="showcase-table__font-values">
                font-size: <strong>16px</strong>
                <br />
                line-height: <strong>24px</strong>
              </td>
              <td class="showcase-table__usage">
                For body copy on dark or primary green backgrounds
              </td>
            </tr>
          </tbody>
        </table>
        <div className="showcase__title l-margin-top--xxlarge">Caption</div>
        <p>
          Use for styling secondary or supporting information, especially in
          forms and disclaimers.
        </p>
        <table class="showcase-table">
          <tbody>
            <tr>
              <td>
                <p class="c-text-content-caption--normal">Caption / Normal</p>
              </td>
              <td>Book 300</td>
              <td>#333</td>
              <td class="showcase-table__font-values">
                font-size: <strong>12px</strong>
                <br />
                line-height: <strong>18px</strong>
              </td>
              <td class="showcase-table__usage">
                For captions on light backgrounds
              </td>
            </tr>
            <tr class="showcase-table__dark-row">
              <td>
                <p class="c-text-content-caption--subtle">Caption / Subtle</p>
              </td>
              <td>Book 300</td>
              <td>#D7D7D7</td>
              <td class="showcase-table__font-values">
                font-size: <strong>12px</strong>
                <br />
                line-height: <strong>18px</strong>
              </td>
              <td class="showcase-table__usage">
                For captions on dark backgrounds
              </td>
            </tr>
            <tr class="showcase-table__darker-row">
              <td>
                <p class="c-text-content-caption--light">Caption / Light</p>
              </td>
              <td>Book 300</td>
              <td>#FFF</td>
              <td class="showcase-table__font-values">
                font-size: <strong>12px</strong>
                <br />
                line-height: <strong>18px</strong>
              </td>
              <td class="showcase-table__usage">
                For captions on dark or primary green backgrounds
              </td>
            </tr>
          </tbody>
        </table>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <p>
          All text should be left-aligned. In desktop, set the parent container
          for text blocks to a width that will allow between 60 and 100
          characters per line. In mobile, text elements should always span 100%
          of the parent container. Keep a margin of 32px between consecutive
          text blocks.
        </p>
      </Layout>
    </>
  )
}

export const code = {
  /*
  text: `<p class="c-text-content">Lorem ipsum dolor ...</p>
`,
  subtle: `<p class="c-text-content--subtle">Lorem ipsum dolor ...</p>
`,
  attention: `<p class="c-text-content--attention">Lorem ipsum dolor ...</p>
`,
  disclaimer: `<p class="c-text-content--disclaimer">Lorem ipsum dolor ...</p>
`,*/
}
